module.exports = __webpack_public_path__ + "static/media/foryou1.43cc9db3.png";